import { addMinutes, format, isValid, isBefore } from 'date-fns'

export const dateHelper = {
  eachMinuteOfInterval: ({ start, end } = {}, { step = 30, includeEnd = false } = {}) => {
    let minites = []
    let next = start

    do {
      minites = [...minites, next]
      next = addMinutes(next, step)
    } while (isBefore(next, end))

    return [...minites, includeEnd ? end : null].filter(Boolean)
  },

  formatDate: (date, { pattern = 'yyyy-MM-dd', ...options } = {}) => (isValid(date) ? format(date, pattern, options) : null),

  formatTime: (date, { pattern = 'HH:mm:ss', ...options } = {}) => (isValid(date) ? format(date, pattern, options) : null),

  formatDateTime: (date, { pattern = 'yyyy-MM-dd HH:mm:ss', ...options } = {}) => (isValid(date) ? format(date, pattern, options) : null),

  formatInterval: ({ start, end }, { pattern = 'MMMM d, yyyy', delimiter = ' - ', ...options } = {}) =>
    isValid(start) && isValid(end) ? `${format(start, pattern, options)}${delimiter}${format(end, pattern, options)}` : null,
}
